/* eslint-disable camelcase */

import * as React from 'react';

type Locale = 'en' | 'es';

type Phrase = (
  locale: Locale,
  params: {
    transformFn: React.FC<{ text: string }>;
  },
) => React.ReactNode;

export const i18n_300_courses_and_challenges__v2: Phrase = (locale, { transformFn }) => {
  const en = <>{transformFn({ text: `300+` })} Courses & Challenges</>;
  const phrases: { [key: string]: undefined | React.ReactNode } = {
    en,
    es: <>{transformFn({ text: `300+` })} cursos y desafíos</>,
  };
  return phrases[locale] || en;
};
